import { useEffect } from 'react';

import { Join } from '@features/Remote/Join';
import { useLoader } from '@hooks/useLoader';
import { useUserInformation } from '@hooks/useUserInformation';
import { AssistantType } from '@src/types/attribution';
import { RequestState } from '@src/types/index';

const RemoteJoin = () => {
  const { setRequestState } = useLoader();
  const userInformation = useUserInformation();
  const isPartner = userInformation?.type === AssistantType.PARTNER;

  useEffect(() => {
    setRequestState(RequestState.success);
  }, [setRequestState]);

  return <Join isPartner={isPartner} />;
};

export { RemoteJoin };
